import React, { lazy, Suspense } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { connect } from 'react-redux';

import Layout from 'layouts';

import RootModal from 'components/RootModal';

const routes = [
  // Terms Page
  {
    path: '/terms',
    Component: lazy(() => import('pages/Terms')),
    exact: true,
  },
  // Policy Page
  {
    path: '/privacy-policy',
    Component: lazy(() => import('pages/Policy')),
    exact: true,
  },
  // About us
  {
    path: '/about-us',
    Component: lazy(() => import('pages/About')),
    exact: true,
  },
  // Data Deletion
  {
    path: '/facebookDataDeletion',
    Component: lazy(() => import('pages/DataDeletion')),
    exact: true,
  },
  // Campaign mobile
  {
    path: '/camp/:id',
    Component: lazy(() => import('pages/CampaignDetailsMobile')),
    exact: true,
  },
  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/Auth/Login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/Auth/ForgotPassword')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/Auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/Auth/500')),
    exact: true,
  },
  // Members Page
  {
    path: '/members',
    Component: lazy(() => import('pages/Members')),
    exact: true,
  },
  // Campaigns Page
  {
    path: '/campaigns',
    Component: lazy(() => import('pages/Campaigns')),
    exact: true,
  },
  {
    path: '/campaigns/new',
    Component: lazy(() => import('pages/CampaignDetails')),
    exact: true,
  },
  {
    path: '/campaigns/:id',
    Component: lazy(() => import('pages/CampaignDetails')),
    exact: true,
  },
  // Winners Page
  {
    path: '/winners',
    Component: lazy(() => import('pages/Winners')),
    exact: true,
  },
  // Home Page
  {
    path: '/home',
    Component: lazy(() => import('pages/Home')),
    exact: true,
  },
];

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
});

const Router = ({ history, routerAnimation }) => {
  return (
    <>
      <ConnectedRouter history={history}>
        <Layout>
          <Route
            render={state => {
              const { location } = state;
              return (
                <SwitchTransition>
                  <CSSTransition
                    key={location.pathname}
                    appear
                    classNames={routerAnimation}
                    timeout={routerAnimation === 'none' ? 0 : 300}
                  >
                    <Switch location={location}>
                      <Route exact path='/' render={() => <Redirect to='/campaigns' />} />
                      {routes.map(({ path, Component, exact }) => (
                        <Route
                          path={path}
                          key={path}
                          exact={exact}
                          render={() => {
                            return (
                              <div className={routerAnimation}>
                                <Suspense fallback={null}>
                                  <Component />
                                </Suspense>
                              </div>
                            );
                          }}
                        />
                      ))}
                      <Redirect to='/auth/404' />
                    </Switch>
                  </CSSTransition>
                </SwitchTransition>
              );
            }}
          />
        </Layout>
      </ConnectedRouter>
      <RootModal />
    </>
  );
};

export default connect(mapStateToProps)(Router);
